function coincideFiltroLocal(item, { estado, tipo, soloPrivadas } = {}) {
  if (!item) return false;
  if (soloPrivadas && !item.privada) return false;
  const estadoFiltro = estado == null || estado === '' ? 'todas' : estado;
  if (estadoFiltro !== 'todas' && estadoFiltro !== 'todos' && item.estado !== estadoFiltro) {
    return false;
  }
  if (tipo && item.tipo !== tipo) return false;
  return true;
}

function aplicarFichaEnLista(items, ficha, filtros = {}) {
  const lista = Array.isArray(items) ? items : [];
  if (!ficha || ficha.id == null) return lista;
  const idx = lista.findIndex((item) => item.id === ficha.id);
  const sigue = coincideFiltroLocal(ficha, filtros);
  if (idx === -1) {
    return sigue ? [ficha, ...lista] : lista;
  }
  if (!sigue) return lista.filter((item) => item.id !== ficha.id);
  return lista.map((item, i) => (i === idx ? { ...item, ...ficha } : item));
}

function estadoPropioDe(ficha) {
  const estado = ficha?.yo?.estado;
  if (estado === 'pendiente' || estado === 'viendo' || estado === 'vista' || estado === 'descartada') {
    return estado;
  }
  return 'pendiente';
}

function fichaConEstadoPropio(ficha, usuarioId, estado, puntuacion) {
  if (!ficha) return ficha;
  const previa = ficha.yo || {};
  const nota = puntuacion === undefined ? previa.puntuacion ?? null : puntuacion;
  const yo = {
    usuario_id: usuarioId,
    nombre: previa.nombre || '',
    estado,
    puntuacion: nota,
    fecha_vista:
      estado === 'vista'
        ? previa.fecha_vista || new Date().toISOString().slice(0, 10)
        : estado === 'pendiente' || estado === 'descartada'
          ? null
          : previa.fecha_vista || null,
  };
  const miembros = (ficha.miembros || []).filter(
    (m) => parseInt(m.usuario_id, 10) !== parseInt(usuarioId, 10)
  );
  miembros.push(yo);
  return { ...ficha, yo, miembros };
}

module.exports = {
  coincideFiltroLocal,
  aplicarFichaEnLista,
  estadoPropioDe,
  fichaConEstadoPropio,
};
